import {
    AsyncThunkPayloadCreator,
    createAsyncThunk,
    miniSerializeError,
    SerializedError,
} from '@reduxjs/toolkit';

import {toaster} from '@gravity-ui/uikit/toaster-singleton';
// import toaster, { ToastOptions } from '~ui/utils/toaster';
import {ToastProps} from '@gravity-ui/uikit';

import {isObject} from '~shared/utils';

import {WikiThunkExtra} from './deps';

export interface ThunkSerializedError extends SerializedError {
    status?: unknown;
    details?: unknown;
}

export function createThunk<Returned, ThunkArg = void>(
    typePrefix: string,
    payloadCreator: AsyncThunkPayloadCreator<
        Returned,
        ThunkArg,
        {extra: WikiThunkExtra; serializedErrorType: ThunkSerializedError}
    >,
) {
    return createAsyncThunk(typePrefix, payloadCreator, {
        serializeError: (error) => {
            // default redux-toolkit serialize function
            // https://redux-toolkit.js.org/api/other-exports#miniserializeerror
            const serializedError = miniSerializeError(error);

            const {details = undefined, status = undefined} = isObject(error) ? error : {};

            return {...serializedError, details, status};
        },
    });
}

export function makeThunkErrorHandler(options: Omit<ToastProps, 'type'>) {
    return function thunkErrorHandler(error: unknown) {
        if (toaster) {
            toaster.add({type: 'error', ...options});
        }

        console.error('[thunk error]:', error);

        // throw error to make thunk rejected
        throw error;
    };
}
